import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { ReportSortOrder } from '@repo/shared/schema';
import { Button } from '@repo/ui/button';
import { ArrowDownWideNarrowIcon, FilterIcon, SearchIcon } from 'lucide-react';
import { type ReactNode, useState } from 'react';

export const ListToolbar = ({
  search,
  onSearch,
  order,
  onOrder,
  sortBy,
  onSortBy,
  children,
}: {
  search: string;
  onSearch: (value: string) => void;
  order: 'asc' | 'desc';
  onOrder: (value: 'asc' | 'desc') => void;
  sortBy: string;
  onSortBy?: (value: string) => void;
  children: ReactNode;
}) => {
  useLocale();

  const [draftOrder, setDraftOrder] = useState(order);
  const [draftSortBy, setDraftSortBy] = useState(sortBy);
  const [draft, setDraft] = useState(search);
  const [showFilters, setShowFilters] = useState(false);
  return (
    <div className="my-8">
      <form
        className="flex flex-wrap items-end gap-3"
        onSubmit={(event) => {
          event.preventDefault();
          onSearch(draft);
        }}
      >
        <label className="flex min-w-48 flex-1 flex-col gap-2 text-xs">
          {t('ui.search')}{' '}
          <input
            className="raven-input"
            onChange={(event) => setDraft(event.target.value)}
            placeholder={t('workspace.searchByClientName')}
            value={draft}
          />
        </label>
        <Button type="submit">
          <SearchIcon className="size-4" />
          {t('ui.search')}{' '}
        </Button>
        <label className="flex flex-col gap-2 text-xs">
          {t('workspace.sortBy')}{' '}
          <select
            className="raven-select"
            onChange={(event) => setDraftSortBy(event.target.value)}
            value={draftSortBy}
          >
            <option value="createdAt">{t('workspace.submissionDate')}</option>
            {onSortBy && <option value="updatedAt">{t('workspace.lastReview')}</option>}
          </select>
        </label>
        <label className="flex flex-col gap-2 text-xs">
          {t('workspace.order')}{' '}
          <select
            className="raven-select"
            onChange={(event) => setDraftOrder(event.target.value as 'asc' | 'desc')}
            value={draftOrder}
          >
            <option value={ReportSortOrder.desc}>{t('workspace.descending')}</option>
            <option value={ReportSortOrder.asc}>{t('workspace.ascending')}</option>
          </select>
        </label>
        <Button
          onClick={() => {
            onOrder(draftOrder);
            onSortBy?.(draftSortBy);
          }}
          type="button"
        >
          <ArrowDownWideNarrowIcon className="size-4" />
          {t('workspace.sort')}{' '}
        </Button>
        <Button
          aria-expanded={showFilters}
          onClick={() => setShowFilters(!showFilters)}
          type="button"
        >
          <FilterIcon className="size-4" />
          {t('workspace.filter')}{' '}
        </Button>
      </form>
      {showFilters && (
        <div className="mt-4 flex flex-wrap items-end gap-4 rounded-xl bg-white p-4">
          {children}
        </div>
      )}
    </div>
  );
};
